module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-Bold.34a18e8.ttf";